import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/ProductTile/ProductHero/EagerImage.js";
const variants = import.meta.webpackContext("/components/ProductTile/ProductHero", { recursive: true, regExp: /\.\/__variants__\/plp\-mweb\-image\-gallery\/v2\/EagerImage\.js/ });
export default pointCut({ joinPoint, variants });